<template>
  <div class="main-content">
    <div class="stake-wrapper p-4 linear-gradient-color">
      <div class="row">
        <div class="col-md-3">
          <div class="stake-info__container">
            <div class="text-center">
              <button
                class="btn btn-staked d-block w-100"
                @click="claim()"
                v-if="stakeOver"
              >
                Claim All
              </button>
              <button class="btn btn-staked d-block w-100" v-if="!stakeOver">
                {{ Math.floor(hoursLeft) + ":" + counter }}
              </button>
              <h4 class="text-capitalize mb-0" v-if="info.reward">
                {{ parseFloat(info.reward).toFixed(2) }} MCC
              </h4>
              <h6 class="mt-0 small-text" v-if="info.reward">Reward</h6>

              <!-- Total Cards Power -->
              <div class="stake-info__content mt-5">
                <h6 class="text-uppercase">Filters</h6>
                <!-- <p class="text-default">Reward are given every 24 hours, user can claim reward for upto 4 days.</p> -->
                <button
                  class="btn btn-success d-block w-100"
                  @click="filter('staked')"
                >
                  Show Staked
                </button>
                <br />
                <button
                  class="btn btn-info d-block w-100"
                  @click="filter('unstaked')"
                >
                  Show Unstaked
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Staking Card -->
        <div class="col-md-9">
          <div class="stake-card__container linear-gradient-color p-2">
            <div class="scrollbar">
              <div class="row" v-if="!isLoading && hide != 'staked'">
                <StakeCard v-for="(item, i) in weapons" :key="i" :row="item" />
              </div>
              <div class="row" v-if="!isLoading" v-show="hide != 'unstaked'">
                <Staked v-for="(item, i) in userStakes" :key="i" :row="item" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import ApiService from "@/services";
import { mapState } from "vuex";
import moment from "moment";
// import Sidebar from "../components/Sidebar.vue";
import StakeCard from "@/components/StakeCard";
import Staked from "@/components/Staked";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Staking",
  components: {
    // Sidebar,
    StakeCard,
    Staked,
  },
  data() {
    return {
      countryStrokeColor: "#fa0909",
      legendBorderRadius: 1,
      showReadyButton: false,
      info: false,
      isLoading: true,
      authenticator: null,
      counter: "0",
      startTime: "",
      endTime: "",
      expiredDate: "",
      winningToken: 0,
      userStakes: [],
      hoursLeft: 1,
      stakeOver: false,
    };
  },
  computed: mapState(["stakes", "weapons", "loaded"]),
  async created() {
    this.isLoading = true;
    await ApiService.getTotalStakes((row) => {
      this.info = row[0];
    });
    await ApiService.getStake((res) => {
      this.userStakes = res;
    });
    await this.$store.dispatch("getWeapons");
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },
  mounted() {
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
    this.authenticator = localStorage.getItem("session-authenticator");
    setTimeout(() => {
      this.isLoading = false;
      this.winningToken = parseFloat(this.info.reward);
      this.endTime = this.info.stake_end;
      this.expiredDate = this.info.expiredDate;
      this.hoursLeft = moment
        .duration(
          moment(this.info.expiredDate).diff(moment(this.info.currentUtc))
        )
        .asHours();
      const dayDiff = moment
        .duration(
          moment(this.info.expiredDate).diff(moment(this.info.currentUtc))
        )
        .asDays();
      // this.duration = res.duration;
      this.countDown = setInterval(() => {
        let currentUtc = moment
          .utc(new Date())
          .format("YYYY-MM-DDTHH:mm:ss.SSSS");
        this.counter = moment
          .utc(moment(this.endTime).diff(currentUtc))
          .format("mm:ss");
        if (
          this.counter == "00:00" ||
          this.counter.indexOf("-") !== -1 ||
          !Object.is(Math.abs(this.hoursLeft), +this.hoursLeft)
        ) {
          this.counter = 0;
          this.stakeOver = true;
          clearInterval(this.countDown);
        }
      }, 1000);
      console.log(Math.round(dayDiff), this.hoursLeft);
      if (this.stakeOver || !(this.hoursLeft > 0)) {
        clearInterval(this.countDown);
        this.counter = 0;
        this.stakeOver = true;
        this.winningToken = parseFloat(this.info.reward) * Math.round(dayDiff);
      }
    }, 2500);
  },
  methods: {
    async claim() {
      await ApiService.transaction(
        {
          contract: process.env.VUE_APP_CONTRACT,
          action: "claimall",
          data: { account: localStorage.getItem("wax_user") },
        },
        (res) => {
          if (res.processed) {
            toast.success("Tokens claimed " + Math.abs(this.winningToken));
            setTimeout(() => {
              this.$router.go();
            }, 2000);
          }
        }
      );
    },
    filter(nfts) {
      this.hide = nfts;
    },
    getImgUrl(pet, isVid) {
      return ApiService.getImgUrl(pet, isVid);
    },
  },
};
</script>
<style scoped>
.content {
  height: 70%;
}
.nft {
  width: 120px;
}
.select-card {
  width: 250px;
  position: absolute;
}
.text-white {
  color: #fff;
}
.stake-info__content .btn-info {
  font-size: 27px;
}
</style>